import { Navigate, Outlet, useLocation } from 'react-router-dom';

/**
 * ProtectedRoute Component — Blocks unauthenticated users from accessing protected pages.
 * Redirects unauthenticated users to /login, retaining their intended destination.
 */
export default function ProtectedRoute() {
  const location = useLocation();
  const token = localStorage.getItem('auth_token');
  const user = localStorage.getItem('auth_user');

  // Consider authenticated if auth_token exists
  const isAuthenticated = Boolean(token || user);

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
